module.exports = __webpack_public_path__ + "static/media/Nihilego_gaussian2.a7bf32c4.png";